module.exports = {
      id: "photo-usage",
      viewBox: "0 0 12 9",
      url: "/" + "sprite-0c9f646beffa24bb04e01488ef4c0ff4.svg#photo",
      toString: function () {
        return this.url;
      }
    }